import { InputProps } from '@toggle/design-system';
import React, { ChangeEventHandler, FC, RefObject } from 'react';

import * as S from './BaseRenameInput.styles';

interface BaseRenameInputProps extends InputProps {
  className?: string;
  value: string;
  ref?: RefObject<HTMLInputElement | null>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  showLengthIndicator?: boolean;
}

export const BaseRenameInput: FC<BaseRenameInputProps> = ({
  className,
  value,
  onChange,
  showLengthIndicator = true,
  maxLength = 30,
  ref = null,
  ...rest
}) => {
  return (
    <S.StyledInput
      className={className}
      ref={ref}
      data-testid="base-rename-input"
      value={value}
      onChange={onChange}
      maxLength={maxLength}
      rightIcon={
        showLengthIndicator ? `${value.length}/${maxLength}` : undefined
      }
      {...rest}
    />
  );
};
